import React from "react";

export class Verbindungsabbruch extends React.PureComponent {
    render() {
        return (
            <React.Fragment>
                <br />
                <h3>Warnung: Verbindung zur Datenbank wurde verloren!</h3>
                <h3>Bitte die Website nicht manuell aktualisieren.</h3>
                <h3>Alle fünf Sekunden wird automatisch versucht, die Verbindung wiederherzustellen.</h3>
            </React.Fragment>
        );
    };
};